import React from 'react';
import styled from 'styled-components';

import { MainLayout } from './main-layout';

type AccountLayoutProps = {
  children: React.ReactNode;
};

export function AccountLayout(props: AccountLayoutProps): JSX.Element {
  const { children } = props;

  return (
    <Container>
      <BackgroundContainer>
        <AccountBoxContainer>{children}</AccountBoxContainer>
      </BackgroundContainer>
    </Container>
  );
}

const Container = styled(MainLayout)`
  min-height: 600px;
`;

const BackgroundContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: 100%;
  width: 100%;
    background-color: ${({ theme }) => theme.colors.primaryGrey};
  }
`;

const AccountBoxContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  flex: 1 0 100%;
  max-width: 1060px;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    margin: 61px 0 122px 0;
    box-shadow: 0 5px 14px ${({ theme }) => theme.colors.blueGrey[95]};
    border-radius: 14px;
  }
`;
